import { useState } from 'react';
import { Link } from 'react-router-dom';

const features = [
  {
    title: 'Product Organization',
    desc: 'Keep every product neatly categorized and instantly searchable with the Superbuy Spreadsheet system.',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20fashion%20boutique%20clothing%20rack%20with%20color%20coordinated%20garments%20hanging%20neatly%2C%20warm%20golden%20track%20lighting%20illuminating%20a%20curated%20collection%20of%20hoodies%20and%20jackets%20in%20earth%20tones%2C%20modern%20retail%20interior%20with%20marble%20flooring%20and%20brass%20fixtures%2C%20luxury%20fashion%20retail%20photography%20with%20soft%20bokeh%20background%2C%20rich%20warm%20atmosphere%20with%20sophisticated%20shopping%20ambiance%2C%20highly%20detailed%20product%20display%20with%20depth%20and%20dimension&width=800&height=1000&seq=feat-v2-org-fashion&orientation=portrait',
    icon: 'ri-layout-grid-line',
    link: '/superbuy-spreadsheet-complete-guide',
  },
  {
    title: 'Price Tracking',
    desc: 'Monitor price changes over time and never miss a deal with built-in tracking capabilities.',
    img: 'https://readdy.ai/api/search-image?query=Premium%20sneaker%20collection%20displayed%20on%20illuminated%20glass%20shelves%20with%20visible%20price%20tags%2C%20modern%20retail%20showroom%20with%20LED%20accent%20lighting%20in%20cool%20white%20tones%2C%20pristine%20white%20sneakers%20alongside%20designer%20athletic%20footwear%2C%20high%20end%20sportswear%20retail%20photography%20with%20clean%20minimal%20aesthetic%2C%20polished%20surfaces%20reflecting%20soft%20light%2C%20luxury%20product%20presentation%20with%20professional%20commercial%20photography%20style&width=800&height=1000&seq=feat-v2-price-sneakers&orientation=portrait',
    icon: 'ri-line-chart-line',
    link: '/superbuy-spreadsheet-complete-guide',
  },
  {
    title: 'Templates Library',
    desc: 'Jump-start your workflow with pre-built Superbuy Spreadsheet templates designed for every use case.',
    img: 'https://readdy.ai/api/search-image?query=Luxury%20designer%20handbags%20and%20leather%20accessories%20arranged%20on%20a%20dark%20walnut%20display%20table%2C%20soft%20dramatic%20spotlight%20from%20above%20creating%20elegant%20highlights%20on%20gold%20hardware%20and%20premium%20leather%20textures%2C%20modern%20boutique%20window%20display%20aesthetic%2C%20rich%20cognac%20and%20deep%20burgundy%20tones%20against%20dark%20background%2C%20high%20fashion%20product%20photography%20with%20sophisticated%20moody%20atmosphere%20and%20refined%20composition&width=800&height=1000&seq=feat-v2-templates-bags&orientation=portrait',
    icon: 'ri-file-copy-line',
    link: '/superbuy-spreadsheet-templates-guide',
  },
  {
    title: 'Safety Guide',
    desc: 'Learn best practices for keeping your spreadsheet data secure and your shopping information protected.',
    img: 'https://readdy.ai/api/search-image?query=Premium%20luxury%20watches%20displayed%20inside%20a%20glass%20secured%20showcase%20with%20subtle%20reflections%2C%20elegant%20jewelry%20store%20interior%20with%20soft%20ambient%20lighting%20and%20velvet%20lined%20displays%2C%20stainless%20steel%20and%20leather%20strap%20timepieces%20arranged%20artistically%2C%20sophisticated%20retail%20security%20aesthetic%20with%20visible%20quality%20craftsmanship%2C%20high%20end%20accessory%20photography%20with%20rich%20metallic%20tones%20and%20polished%20surfaces%20gleaming%20under%20controlled%20lighting&width=800&height=1000&seq=feat-v2-safety-watches&orientation=portrait',
    icon: 'ri-shield-check-line',
    link: '/superbuy-spreadsheet-safety-guide',
  },
  {
    title: 'How-To Workflow',
    desc: 'Follow our step-by-step workflow to set up and optimize your Superbuy Spreadsheet from scratch.',
    img: 'https://readdy.ai/api/search-image?query=Casual%20streetwear%20outfit%20flat%20lay%20on%20textured%20concrete%20surface%2C%20carefully%20styled%20combination%20of%20distressed%20denim%20jeans%20vintage%20band%20tshirt%20and%20classic%20canvas%20sneakers%2C%20natural%20daylight%20from%20large%20industrial%20window%20casting%20long%20dramatic%20shadows%2C%20urban%20fashion%20editorial%20photography%20with%20raw%20authentic%20grunge%20aesthetic%2C%20cool%20neutral%20tones%20with%20pops%20of%20faded%20color%2C%20contemporary%20youth%20culture%20fashion%20composition%20with%20effortless%20style&width=800&height=1000&seq=feat-v2-howto-streetwear&orientation=portrait',
    icon: 'ri-guide-line',
    link: '/superbuy-spreadsheet-beginner-guide',
  },
  {
    title: 'Learning Center',
    desc: 'Dive deep into our comprehensive guides and master every aspect of spreadsheet-based shopping.',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20arrangement%20of%20luxury%20perfume%20bottles%20and%20fragrance%20products%20on%20a%20sleek%20marble%20surface%2C%20varied%20glass%20bottle%20shapes%20with%20amber%20and%20clear%20liquids%20catching%20soft%20diffused%20light%2C%20elegant%20beauty%20retail%20display%20with%20gold%20accents%20and%20minimalist%20packaging%2C%20sophisticated%20cosmetic%20photography%20with%20ethereal%20soft%20focus%20background%20and%20crystalline%20reflections%2C%20premium%20fragrance%20collection%20presented%20with%20refined%20commercial%20beauty%20aesthetic&width=800&height=1000&seq=feat-v2-learn-perfume&orientation=portrait',
    icon: 'ri-book-open-line',
    link: '/superbuy-spreadsheet-complete-guide',
  },
];

const templates = [
  { name: 'Product Research Template', desc: 'Track and compare products across multiple stores' },
  { name: 'Price Tracking Template', desc: 'Monitor price fluctuations and set alerts' },
  { name: 'Order Management Template', desc: 'Keep all your orders organized in one place' },
  { name: 'Comparison Template', desc: 'Side-by-side product feature comparison' },
];

export default function Features() {
  const [hoveredIdx, setHoveredIdx] = useState<number | null>(null);

  return (
    <>
      <section id="why-choose" className="py-16 md:py-24 bg-background-50">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="text-center mb-14">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">Why Choose <span className="italic font-normal text-accent-500">Superbuy Spreadsheet</span>?</h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">Six powerful reasons why thousands of shoppers trust our spreadsheet system for their purchasing decisions.</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {features.map((feat, idx) => (
              <Link
                to={feat.link}
                key={feat.title}
                className="group relative rounded-lg overflow-hidden bg-background-100 cursor-pointer transition-all duration-500 block"
                style={{ aspectRatio: '3/4' }}
                onMouseEnter={() => setHoveredIdx(idx)}
                onMouseLeave={() => setHoveredIdx(null)}
              >
                <img
                  src={feat.img}
                  alt={feat.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <span className="w-8 h-8 flex items-center justify-center text-white/80 mb-2">
                    <i className={`${feat.icon} text-lg`}></i>
                  </span>
                  <h3 className="text-white font-heading text-lg md:text-xl font-semibold">{feat.title}</h3>
                  <p className={`mt-1 text-white/70 text-xs md:text-sm transition-all duration-300 ${hoveredIdx === idx ? 'opacity-100 max-h-20' : 'opacity-0 max-h-0 overflow-hidden'}`}>{feat.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section id="templates" className="py-16 md:py-24 bg-background-100">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">Superbuy Spreadsheet <span className="italic font-normal text-accent-500">Templates</span></h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">Pre-built templates to jump-start your spreadsheet workflow.</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {templates.map((tpl) => (
              <div key={tpl.name} className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 hover:border-accent-300/60 transition-all cursor-pointer group">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500 group-hover:bg-accent-500 group-hover:text-white transition-all">
                  <i className="ri-file-text-line text-lg"></i>
                </span>
                <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-900">{tpl.name}</h3>
                <p className="mt-2 text-foreground-600 text-xs md:text-sm">{tpl.desc}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-10">
            <Link to="/superbuy-spreadsheet-complete-guide" className="inline-flex items-center gap-2 text-sm font-semibold text-accent-500 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap">
              Explore Superbuy Spreadsheet Templates
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
            </Link>
          </div>
        </div>
      </section>

      <section id="comparisons" className="py-16 md:py-24 bg-background-50">
        <div className="max-w-[900px] mx-auto px-6 md:px-10">
          <div className="text-center mb-10">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">Superbuy Spreadsheet <span className="italic font-normal text-accent-500">Compared</span></h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base">See how our spreadsheet system stacks up against other methods.</p>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="border-b border-background-300/60">
                  <th className="py-3 px-4 text-sm font-semibold text-foreground-800">Criteria</th>
                  <th className="py-3 px-4 text-sm font-semibold text-accent-500">Superbuy Spreadsheet</th>
                  <th className="py-3 px-4 text-sm font-semibold text-foreground-700">Excel</th>
                  <th className="py-3 px-4 text-sm font-semibold text-foreground-700">Google Sheets</th>
                  <th className="py-3 px-4 text-sm font-semibold text-foreground-700">Manual Notes</th>
                </tr>
              </thead>
              <tbody className="text-sm text-foreground-600">
                {['Ease Of Use', 'Organization', 'Collaboration', 'Customization', 'Efficiency'].map((criteria) => (
                  <tr key={criteria} className="border-b border-background-200/50">
                    <td className="py-3 px-4 font-medium text-foreground-800">{criteria}</td>
                    <td className="py-3 px-4 text-accent-500 font-medium">Best</td>
                    <td className="py-3 px-4">Good</td>
                    <td className="py-3 px-4">Good</td>
                    <td className="py-3 px-4">Limited</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section id="how-to" className="py-16 md:py-24 bg-background-100">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">How To Use <span className="italic font-normal text-accent-500">Superbuy Spreadsheet</span></h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">Five simple steps to master your shopping workflow.</p>
          </div>
          <div className="flex flex-col md:flex-row items-start gap-6 md:gap-0">
            {[
              { step: '01', title: 'Collect Product Data', desc: 'Gather product information from your favorite stores' },
              { step: '02', title: 'Organize Information', desc: 'Categorize and structure your product data efficiently' },
              { step: '03', title: 'Compare Options', desc: 'Evaluate products side by side with our templates' },
              { step: '04', title: 'Track Updates', desc: 'Monitor price and availability changes over time' },
              { step: '05', title: 'Optimize Decisions', desc: 'Make smarter purchases with data-driven insights' },
            ].map((item, idx) => (
              <div key={item.step} className="flex-1 flex flex-col items-center text-center px-3 relative">
                <div className="w-14 h-14 rounded-full bg-accent-500 text-white flex items-center justify-center font-heading text-lg font-bold">{item.step}</div>
                {idx < 4 && <div className="hidden md:block absolute top-7 left-[60%] w-[80%] h-[1px] bg-background-300/60"></div>}
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-900">{item.title}</h3>
                <p className="mt-1 text-foreground-600 text-xs md:text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="safety" className="py-16 md:py-24 bg-background-50">
        <div className="max-w-[900px] mx-auto px-6 md:px-10">
          <div className="text-center mb-10">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">Is Superbuy Spreadsheet <span className="italic font-normal text-accent-500">Safe</span>?</h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">Understanding how to protect your data when using spreadsheets for shopping.</p>
          </div>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
            Security is a top priority when managing shopping data with any spreadsheet tool. The Superbuy Spreadsheet approach emphasizes data protection through several key practices: always avoid sharing sensitive personal information within shared spreadsheets, verify spreadsheet sources before downloading templates from the internet, steer clear of suspicious downloads that claim to offer "premium" templates, and use secure devices when accessing your shopping data. By following these guidelines, you can enjoy the organizational benefits of the Superbuy Spreadsheet system while keeping your information safe.
          </p>
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="border-b border-background-300/60">
                  <th className="py-3 px-4 text-sm font-semibold text-foreground-800">Risk</th>
                  <th className="py-3 px-4 text-sm font-semibold text-foreground-800">Problem</th>
                  <th className="py-3 px-4 text-sm font-semibold text-foreground-800">Solution</th>
                </tr>
              </thead>
              <tbody className="text-sm text-foreground-600">
                <tr className="border-b border-background-200/50">
                  <td className="py-3 px-4 font-medium text-foreground-800">Data Sharing</td>
                  <td className="py-3 px-4">Accidental exposure of personal data</td>
                  <td className="py-3 px-4 text-accent-500">Use private sheets and review permissions</td>
                </tr>
                <tr className="border-b border-background-200/50">
                  <td className="py-3 px-4 font-medium text-foreground-800">Template Sources</td>
                  <td className="py-3 px-4">Malicious third-party templates</td>
                  <td className="py-3 px-4 text-accent-500">Download only from trusted sources</td>
                </tr>
                <tr>
                  <td className="py-3 px-4 font-medium text-foreground-800">Device Security</td>
                  <td className="py-3 px-4">Access from unsecured devices</td>
                  <td className="py-3 px-4 text-accent-500">Use password-protected devices</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section id="learning" className="py-16 md:py-24 bg-background-100">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">Superbuy Spreadsheet <span className="italic font-normal text-accent-500">Learning Center</span></h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            {[
              { name: 'Beginner Guides', path: '/superbuy-spreadsheet-beginner-guide' },
              { name: 'Templates', path: '/superbuy-spreadsheet-templates-guide' },
              { name: 'Comparisons', path: '/superbuy-spreadsheet-complete-guide' },
              { name: 'Advanced Tips', path: '/superbuy-spreadsheet-complete-guide' },
              { name: 'Safety', path: '/superbuy-spreadsheet-safety-guide' },
            ].map((cat) => (
              <Link
                key={cat.name}
                to={cat.path}
                className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 hover:border-accent-300/60 transition-all text-center cursor-pointer group"
              >
                <span className="w-10 h-10 flex items-center justify-center mx-auto rounded-lg bg-secondary-100 text-secondary-500 group-hover:bg-accent-500 group-hover:text-white transition-all">
                  <i className="ri-bookmark-line text-lg"></i>
                </span>
                <h3 className="mt-3 font-heading text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">{cat.name}</h3>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}